"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.expireIdentityVerification = void 0;
function expireIdentityVerification($http, publicApiBaseUrl, secretHash, visitToken) {
    if (visitToken) {
        $http.post("".concat(publicApiBaseUrl, "/").concat(secretHash, "/expire-identify/").concat(visitToken));
    }
}
exports.expireIdentityVerification = expireIdentityVerification;
